export default "__VITE_ASSET__DmzErnMP__"